import React from 'react'

const Settings = () => {
  return (
    <div>
      <h1>setting page</h1>
    </div>
  )
}

export default Settings
